import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface ImportResumeData {
  sucesso: string[];
  erro: string[];
}

@Component({
  selector: 'app-import-resume-dialog',
  templateUrl: './import-resume-dialog.component.html',
  styleUrls: ['./import-resume-dialog.component.sass']
})
export class ImportResumeDialogComponent {
constructor(
    public dialogRef: MatDialogRef<ImportResumeDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ImportResumeData
  ) {}

  confirm(): void {
    this.dialogRef.close('confirm');
  }

  back(): void {
    this.dialogRef.close('back');
  }

}
